import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export default function OfflineBanner() {
  const online = useOnlineStatus();

  if (online) return null;

  return (
    <div className="sticky top-16 z-40 border-b border-[#1C2A44] bg-[hsl(215,15%,14%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center gap-2 text-xs text-[hsl(210,9%,91%)]">
          <WifiOff className="w-4 h-4 text-[#00FF8C]" />
          <span>You’re offline. Some pages may not load until you reconnect.</span>
        </div>
      </div>
    </div>
  );
}
